export default __webpack_public_path__ + "static/testimonialHolder5-c5964d4178c8b2780b222b6578d8176a.png";